<template>
  <v-dialog
    v-model="dialogModel"
    :fullscreen="$vuetify.breakpoint.mdAndDown"
    max-width="600px"
  >
    <v-card>
      <v-card-title
        class="primary accent--text"
      >
        {{ dialogTitle() }}
      </v-card-title>
      <v-card-text>
        <v-row
          v-if="dialogMode === 'list'"
        >
          <v-col cols="12">
            <v-row>
              <v-col
                cols="12"
                style="text-align: center;"
              >
                <v-btn
                  rounded
                  outlined
                  color="primary"
                  class="mb-3"
                  @click="dialogMode = 'create'"
                >
                  <v-icon left small>add</v-icon>

                  Add Schedule Group
                </v-btn>
              </v-col>
            </v-row>

            <v-list>
              <template v-for="(group, gidx) in getScheduleGroups">
                <v-list-item :key="`schedule_group_${gidx}`">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ group.label}}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ group.description }}
                    </v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-menu left>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          v-on="on"
                        >
                          <v-icon>more_vert</v-icon>
                        </v-btn>
                      </template>

                      <v-list dense>
                        <v-list-item
                          @click="onEditGroup(group)"
                        >
                          <v-list-item-content>
                            <v-list-item-title>
                              <v-icon left small>edit</v-icon>

                              Edit
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item
                          @click="onArchiveGroup(group)"
                        >
                          <v-list-item-content>
                            <v-list-item-title>
                              <v-icon left small>archive</v-icon>

                              Archive
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-list-item-action>
                </v-list-item>

                <v-divider
                  v-if="gidx + 1 < getScheduleGroups.length"
                  :key="`sg_divider_${gidx}`"
                />
              </template>
            </v-list>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="12">
            <v-row>
              <v-col cols="12" style="text-align: center;">
                <v-btn
                  rounded
                  outlined
                  color="primary"
                  class="mb-3"
                  @click="dialogMode = 'list'"
                >
                  <v-icon left small>format_list_bulleted</v-icon>

                  List Groups
                </v-btn>
              </v-col>
            </v-row>

            <v-text-field
              v-model="scheduleGroupModel.label"
              outlined
              dense
              type="text"
              label="Schedule Group Name"
            />
            <v-text-field
              v-model="scheduleGroupModel.description"
              outlined
              dense
              type="text"
              label="Description"
            />
            <scheduled-product-select
              :init-selected="scheduleGroupModel.entities.products"
              @change-selected="onChangeProducts($event)"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          rounded
          outlined
          :disabled="isLoading"
          @click="dialogModel = false"
        >
          {{ dialogMode === 'list' ? 'Close' : 'Cancel' }}
        </v-btn>
        <v-btn
          v-if="dialogMode === 'create' || dialogMode === 'edit'"
          rounded
          outlined
          color="primary"
          :disabled="isLoading"
          :loading="isLoading"
          @click="onSave()"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { isEqual, get, isEmpty } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import ScheduledProductSelect from "../Product/ScheduledProductSelect"

export default {
  components: {
    ScheduledProductSelect,
  },
  props: {
    model: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: '' // edit, create, list ?
    },
    scheduleGroup: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      isLoading: false,
      dialogModel: false,
      dialogMode: 'list',
      emptyModel: {
        id: '',
        label: '',
        description: '',
        entities: {
          products: [],
          users: []
        }
      },
      scheduleGroupModel: { },
      selectedProducts: []
    }
  },
  computed: {
    ...mapGetters(['getScheduleGroups']),
    // cant use imported functions directly in the view?
    _isEmpty: () => (val) => isEmpty(val),
    isEditMode() {
      return this.dialogMode === 'edit'
    },
    title() {
      return isEmpty(this.scheduleGroup.id)
        ? 'New Schedule Group'
        : this.scheduleGroupModel.name
    }
  },
  watch: {
    'mode'(val) {
      this.dialogMode = val
    },
    'model'() {
      this.dialogModel = !!this.model
      // If the model was closed, reset the loading
      if (this.dialogModel === false) {
        this.isLoading = false
        this.$emit('cancel')
      }
    },
    'dialogModel'() {
      if (this.dialogModel === false) {
        this.isLoading = false
        this.$emit('cancel')
      }
    }
  },
  created() {
    this.scheduleGroupModel = { ...this.emptyModel }
  },
  methods: {
    ...mapActions([ 'updateScheduleGroup', 'createScheduleGroup' ]),
    onEditGroup(group) {
      this.dialogMode = 'edit'
      this.scheduleGroupModel = { ...group }
      console.log(this.scheduleGroupModel)
    },
    onArchiveGroup(group) {

    },
    onCreateGroup() {

    },
    dialogTitle() {
      let title = 'Schedule Group' // default

      switch (this.dialogMode) {
        case 'create':
          title = 'Create Schedule Group'
          break;
        case 'update':
          title = 'Update Schedule Group'
          break;
        case 'list':
          title =  'Schedule Groups'
          break;
      }

      return title
    },
    onChangeProducts(productIds) {
      this.selectedProducts = [ ...productIds ]
    },
    onSave() {
      const payload = {
        ...this.scheduleGroupModel,
        entities: {
          products: [ ...this.selectedProducts ]
        }
      }

      console.log('payload', payload)

      const doEdit = () => {
        this.isLoading = true
        this.updateScheduleGroup(payload)
          .then(() => {
            this.dialogMode = 'list'
          })
          .finally(() => {
            this.isLoading = false
          })
      }

      const doCreate = () => {
        this.isLoading = true
        this.createScheduleGroup(payload)
          .then(() => {
            this.dialogMode = 'list'
          })
          .finally(() => {
            this.isLoading = false
          })
      }

      this.isEditMode ? doEdit() : doCreate()
    },
    handleError(e) {
      const errMsg = e.response.data.message
      this.$store.commit('showSnack', { text: errMsg, color: 'error' })
    }
  }
}
</script>
